import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

if (/\/{2,}/.test(window.location.pathname)) {
  window.history.replaceState(null, "", window.location.pathname.replace(/\/{2,}/g, "/") + window.location.search + window.location.hash);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
